export const registerServiceWorker = (): void => {
  if ("serviceWorker" in navigator) {
    // Use requestIdleCallback if supported
    const register = () => {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration: ServiceWorkerRegistration) => {
          console.log("✅ Service Worker Registered:", registration);
        })
        .catch((error: Error) => {
          console.error("❌ Service Worker Registration Failed:", error);
        });
    };

    if ("requestIdleCallback" in window) {
      requestIdleCallback(register);
    } else {
      // Fallback if requestIdleCallback not supported
      setTimeout(register, 3000);
    }
  }
};
